export default __webpack_public_path__ + "static/media/reset-poster.fe411607.svg";